import gql from "graphql-tag";

const DELETE_PRODUCT_MUTATION = gql`  
mutation DeleteProduct($id: String!){
  deleteProduct(id: $id)
}
`;

export default DELETE_PRODUCT_MUTATION;